import api from '../index'
import baseUrl from '../baseUrl'
import urls from './urls'
export default {
  courseLogin({ params, header, errorFn, loadingText }) {
    // return出去了一个promise
    return api.get({
      url: this.formatUrl(urls.courseLogin),
      params,
      header,
      errorFn,
      loadingText
    })
  },
  switchClienId({ params, header, errorFn, loadingText }) {
    // return出去了一个promise
    return api.get({
      url: this.formatUrl(urls.switchClienId.url),
      params: {
        ...params,
        wsfunction: urls.switchClienId.wsfunction
      },
      header,
      errorFn,
      loadingText
    })
  },
  formatUrl(url) {
    if (process.env.VUE_APP_BASIC_API === 'dev') {
      return url
    } else {
      return baseUrl.getUrl() + url
    }
  }
}
